export const categories = [
  {
    id: 'safe-access',
    name: '安全访问',
    slug: 'safe-access',
    description: '了解如何安全、匿名地访问成人网站，防范恶意软件与网络攻击',
    icon: 'ri-shield-check-line',
    color: 'primary',
    articleCount: 8,
  },
  {
    id: 'privacy-protection',
    name: '隐私保护',
    slug: 'privacy-protection',
    description: '掌握个人隐私防护技巧，避免浏览记录与身份信息泄露',
    icon: 'ri-eye-off-line',
    color: 'accent',
    articleCount: 6,
  },
  {
    id: 'content-filtering',
    name: '内容分级',
    slug: 'content-filtering',
    description: '使用内容分级系统与过滤工具，确保浏览内容符合个人标准',
    icon: 'ri-filter-line',
    color: 'secondary',
    articleCount: 7,
  },
  {
    id: 'compliance',
    name: '合规使用',
    slug: 'compliance',
    description: '了解各国法律法规，确保在合法合规的框架下使用成人平台',
    icon: 'ri-scales-line',
    color: 'primary',
    articleCount: 5,
  },
  {
    id: 'family-safety',
    name: '家庭防护',
    slug: 'family-safety',
    description: '设置家长控制与家庭网络过滤，保护未成年人免受不当内容影响',
    icon: 'ri-home-smile-line',
    color: 'accent',
    articleCount: 6,
  },
  {
    id: 'digital-wellness',
    name: '数字健康',
    slug: 'digital-wellness',
    description: '建立健康的网络使用习惯，识别和应对成瘾风险',
    icon: 'ri-heart-pulse-line',
    color: 'secondary',
    articleCount: 4,
  },
];

export const categoryMap: Record<string, typeof categories[number]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});